import { ESymbolCategory, IDisplayItem, IReportParameter, ISymbol } from "@kuika/kuika-cl-model";
import { ScreenDesignHelper } from "./screen-design-helper";

const PARAM_REGEX = /(?<![.\w])@([a-zA-Z_][a-zA-Z0-9_]*)/g;

export class ReportParameterHelper {
  static extractParametersFromText(text: string): string[] {
    if (!text) return [];
    const matches = new Set<string>();
    let match: RegExpExecArray | null;
    PARAM_REGEX.lastIndex = 0;
    while ((match = PARAM_REGEX.exec(text)) !== null) {
      matches.add(match[1]);
    }
    return Array.from(matches);
  }

  static scanLabelsForParameters(rootDI: IDisplayItem): string[] {
    if (!rootDI) return [];
    const allChildren = ScreenDesignHelper.getAllChildrenForDI(rootDI);
    const paramNames = new Set<string>();

    for (const di of allChildren) {
      if (di.item?.name !== "Label") continue;
      const valueProp = di.item.properties?.find((p) => p.name === "value");
      const fixedValue = valueProp?.symbol?.fixedValue;
      if (typeof fixedValue === "string") {
        for (const name of ReportParameterHelper.extractParametersFromText(fixedValue)) {
          paramNames.add(name);
        }
      }
    }

    return Array.from(paramNames);
  }

  static createDefaultSymbol(): ISymbol {
    return {
      category: ESymbolCategory.none,
      label: "",
      description: ""
    };
  }

  static mergeParameters(scannedNames: string[], existingParams: IReportParameter[]): IReportParameter[] {
    const existingMap = new Map<string, IReportParameter>();
    if (existingParams) {
      for (const param of existingParams) {
        existingMap.set(param.name, param);
      }
    }

    return scannedNames.map((name) => {
      const existing = existingMap.get(name);
      if (existing) return existing;
      return {
        name,
        symbol: ReportParameterHelper.createDefaultSymbol()
      };
    });
  }
}
